<template>
    <div class="form-input-textarea" :class="{'form-input-textarea--is-expanded': isExpanded}">
      <textarea :name="name"
          ref="input"
          :value="value"
          @focus="isFocused = true"
          @blur="isFocused = false"
          @input="$emit('input', $event.target.value)"

          @keyup.enter="forceNewLine"
      ></textarea>
      <div ref="bottom-line" class="bottom-line">
        <div class="before"></div>
      </div>
      <div class="placeholder h6">{{placeholder}}</div>
    </div>
</template>

<script>

    //import comp from '@/path/to/comp.vue';    //от папки src указанной в webpack
  import autosize from 'autosize';

  export default {
    components: {
    },
    //еще нужно свойство type, чтобы на мобилах правильные клавиатуры вываливались
    props: {
      placeholder: {
        type: String,
        default: null
      },
      value: String,
      name: String,
    },
    data(){
      return {
        isFocused: false,
        isMounted: false, //чисто техническое поле
      }
    },
    computed: {
      isExpanded(){
        if(!this.isMounted) return;
        return this.isFocused || this.value;
      }
    },
    methods: {
      forceNewLine(e){
        //фикс для ctrl
//                if(e.ctrlKey){
        let input = this.$refs.input;
//        input.value = input.value + '\n';
        autosize.update(input);
        input.scrollTop = input.scrollHeight;
//                }
      },
    },
    mounted(){
      this.isMounted = true;
      autosize(this.$refs.input);
    }

  }
</script>
<style scoped lang="scss">
    @import 'src/scss/vars';    //от папки со сборкой
    .form-input-textarea {
      --place-for-top-placeholder: calc( 24 * var(--px));
      position: relative;
      padding-top: var(--place-for-top-placeholder);
      textarea {
        display: block;
        font-family: 'din-display', sans-serif;
        width: 100%;
        min-height:calc( var(--sizeCell) * 3);
        max-height: calc( 112 * var(--px));
        padding-left:var(--sizeCell);
        padding-right:var(--sizeCell);
        border: none;
        outline: none;
        color: white;
        background-color: $clrBgDarkLess;
        resize: none;
        padding-top: calc( 16 * var(--px));

        padding-bottom: calc( 16 * var(--px));
      }
      .bottom-line {
        height: calc( 2 * var(--px));
        background-color: white;
        position: relative;
        overflow: hidden; //fix for Edge
        transition: width $timeMed, background-color $timeShort;
        .before {
          content: '';

          position: absolute;
          height: calc(2 * var(--px));
          width: 0;
          background-color: $clrAcc;
          transition: width $timeMed;
          left: 50%;
          transform: translate(-50%, 0px);

        }
      }
      .placeholder {
        position: absolute;
        /*outline: 1px solid darkred;*/
        top: calc( 14 * var(--px) + var(--place-for-top-placeholder));
        left:var(--sizeCell);
        transition: all $timeShort;
        pointer-events: none;
      }
    }
    .form-input-textarea.form-input-textarea--is-expanded {
      .placeholder {
        top: calc( -20 * var(--px) + var(--place-for-top-placeholder));
        font-size: calc( 15 * var(--px));
        left: 0;
      }
      .bottom-line {
        .before {
          width: calc(100% + 1px);
        }
      }
    }
    .form-input-textarea.form-input-textarea--has-error {
      .bottom-line {
        background-color: $clrErr;
        .before {
          background-color: $clrErr;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/form-input-textarea.vue